export let VerOrdenesComponent = {
    selector: 'ordenesDetail',
    template: require('./ver-ordenes.html'),
    bindings: {
        orden: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(OrdenesService, $route, $location) {
            Object.assign(this, {OrdenesService, $route, $location});
        }

        cambiarEstado() {
            let nuevoEstado = 'enProceso';
            if (this.orden.estado === 'enProceso') nuevoEstado = 'finalizada';
            this.OrdenesService.cambiarEstadoOrden(this.orden._id, {estado: nuevoEstado})
                .then(() => {
                    if (nuevoEstado === 'enProceso') {
                        this.$route.reload();
                    } else {
                        this.$location.path('/ordenes');
                    }
                })
                .catch(err => console.log(err.data.message));
        }
    }
};


// WEBPACK FOOTER //
// ./client/app/ordenes-route/ver/ver-ordenes.component.js